import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from 'react-query';
import { NotifyModal } from 'components';
import { DIALOG_KINDS } from 'constants/dialogKinds';
import { deleteRole } from 'api/roleApi';

export const DeleteRoleModal = ({
  optimisticallyDeleteRole,
  role,
  setRole,
  setSnackbarError,
  setSnackbarSuccess,
  toggleDeleteModal,
  toggleDrawer,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const handleConfirm = () => {
    if (!isLoading) {
      setIsLoading(true);

      return deleteRole(role.name)
        .then(() => {
          queryClient.invalidateQueries(['getRoles']);
          optimisticallyDeleteRole(role);
          setSnackbarSuccess();
        })
        .catch(() => {
          setSnackbarError();
        })
        .finally(() => {
          setIsLoading(false);
          setRole(null);
          toggleDrawer();
          toggleDeleteModal();
        });
    }

    return undefined;
  };

  return (
    <NotifyModal
      open
      title="Delete Role"
      cancelText="No"
      confirmText="Yes"
      mode={DIALOG_KINDS.ERROR}
      onCancel={toggleDeleteModal}
      onConfirm={handleConfirm}
      isLoading={isLoading}
    >
      <div
        className="m-notify-modal m-notify-modal__main"
        data-testid="PlatformAdminUI-RolesAndPermissions-DeleteRoleModal-Body"
      >
        This is permanent, are you sure you want to delete &ldquo;{role?.name}
        &ldquo;?
      </div>
    </NotifyModal>
  );
};

DeleteRoleModal.propTypes = {
  toggleDeleteModal: PropTypes.func.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  optimisticallyDeleteRole: PropTypes.func,
  role: PropTypes.object,
  setRole: PropTypes.func,
  setSnackbarError: PropTypes.func,
  setSnackbarSuccess: PropTypes.func,
};

export default DeleteRoleModal;
